import { render, staticRenderFns } from "./classDorm.vue?vue&type=template&id=7b101883&scoped=true"
import script from "./classDorm.vue?vue&type=script&lang=js"
export * from "./classDorm.vue?vue&type=script&lang=js"
import style0 from "./classDorm.vue?vue&type=style&index=0&id=7b101883&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b101883",
  null
  
)

export default component.exports